const dataTypeCodes = {
  DATE: 135,
  INT: 136,
  NUMERIC: 137,
  VARCHAR: 138,
  BOOL: 409,
};

export default dataTypeCodes;
